import { createPremiumModule } from '@wix/premium-fed-sdk/@premium-module';
import { DomainIsTaken, SubdomainRootIsTaken, ExternalViewerSubdomainNotAllowed, ExternalViewerPointingDomain } from './DomainSearchErrors';
import { StatusesDataHooksExtension } from './StatusesDataHooksExtension';
import { PurchaseRootIsRequired } from './DomainSearchErrors/PurchaseRootIsRequired';
export const StatusesModule = createPremiumModule('statusesModule', [StatusesDataHooksExtension], () => ({
  SDK: {
    Components: {
      DomainIsTaken,
      SubdomainRootIsTaken,
      PurchaseRootIsRequired,
      ExternalViewerSubdomainNotAllowed,
      ExternalViewerPointingDomain
    }
  }
}));
//# sourceMappingURL=StatusesModule.js.map